import { Button, Container, Grid } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import styles from '../style.module.scss';

const ContactFormComponent = (props) => {
  const { customerData, validated, updateCustomerData, handleSubmit, errorMsg } = props;
  return (
    <div className={styles.contactContainer}>
      <Container maxWidth="lg">
        <div className={styles.InfoDiv}>
          <Grid container spacing={5} id="startSelling">
            <Grid item md={8} xl={8} lg={8} sm={12} xs={12}>
              <h2 className={`${styles.contactMainText}`}>Start Selling with us!</h2>
              <p className={`${styles.contactSecondaryText} mt-5`}>
                Take advantage of flexible pricing structure.
                <br />
                We’ll show you the product and answer all your questions in 30minutes
              </p>
              <div className="d-flex align-items-start pt-5" style={{ marginTop: '40px' }}>
                <img
                  alt="arzooo-header-logo"
                  className={styles.icon1Container}
                  src="/images/correctIcon.svg"
                ></img>
                <p className={`${styles.feature1Text} text-white mb-0`} style={{ opacity: 1 }}>
                  {' '}
                  Cut down your logistics cost by 100%.
                </p>
              </div>
              <div className="d-flex align-items-start pt-4">
                <img
                  alt="arzooo-header-logo"
                  className={styles.icon1Container}
                  src="/images/correctIcon.svg"
                ></img>
                <p className={`${styles.feature1Text} text-white mb-0`} style={{ opacity: 1 }}>
                  {' '}
                  Increase your revenue by more than 50%, Our average customer <br />
                  doubles their revenue within 14 months of implementing our platform.
                </p>
              </div>
            </Grid>
            <Grid item md={4} lg={4} xl={4} sm={12} xs={12}>
              <div className={styles.formContainer}>
                <h3 className="mb-4">Fill in your details</h3>
                <Form.Label htmlFor="name">Name</Form.Label>
                <Form.Control
                  type="text"
                  id="name"
                  aria-describedby="name"
                  placeholder="Enter name here"
                  className="shadow-none"
                  name="ownerName"
                  required
                  isInvalid={errorMsg.ownerName}
                  value={customerData.ownerName || ''}
                  onChange={(e) => updateCustomerData(e)}
                />
                <Form.Control.Feedback type="invalid">Name is required.</Form.Control.Feedback>
                <Form.Label htmlFor="mobile" className="mt-4">
                  Phone Number
                </Form.Label>
                <Form.Control
                  type="number"
                  id="mobile"
                  aria-describedby="mobile"
                  placeholder="Enter phone number here"
                  className="shadow-none"
                  name="mobileNumber"
                  required
                  isInvalid={errorMsg.mobileNumber}
                  value={customerData.mobileNumber || ''}
                  onChange={(e) => updateCustomerData(e)}
                />
                <Form.Control.Feedback type="invalid">
                  Phone Number is required.
                </Form.Control.Feedback>
                <Form.Label htmlFor="city" className="mt-4">
                  City
                </Form.Label>
                <Form.Control
                  id="city"
                  aria-describedby="city"
                  placeholder="Enter city here"
                  className="shadow-none"
                  name="city"
                  required
                  isInvalid={errorMsg.city}
                  value={customerData.city || ''}
                  onChange={(e) => updateCustomerData(e)}
                />
                <Form.Control.Feedback type="invalid">City is required.</Form.Control.Feedback>
                <Form.Label htmlFor="category" className="mt-4">
                  Category
                </Form.Label>
                <Form.Control
                  id="category"
                  aria-describedby="category"
                  placeholder="Select category"
                  className="shadow-none"
                  as="select"
                  name="category"
                  required
                  isInvalid={errorMsg.category}
                  value={customerData.category}
                  onChange={(e) => updateCustomerData(e)}
                >
                  <option selected disabled>
                    {' '}
                    Select category
                  </option>
                  <option value="Tv and appliances">Tv and appliances</option>
                  <option value="Kitchen appliances">Kitchen appliances</option>
                  <option value="Other electronics">Other electronics</option>
                </Form.Control>
                <Form.Control.Feedback type="invalid">Category is required.</Form.Control.Feedback>
                <div className="d-flex justify-content-center">
                  <Button
                    className="mt-5"
                    style={{ width: '50%' }}
                    variant="contained"
                    color="primary"
                    type="button"
                    onClick={(e) => {
                      handleSubmit(e);
                    }}
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </Container>
    </div>
  );
};
export default ContactFormComponent;
